import React, { useMemo } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import GAME_CONFIGS from './config/gameConfigs';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
import { PhantomWalletAdapter, SolflareWalletAdapter } from '@solana/wallet-adapter-wallets';
import { clusterApiUrl } from '@solana/web3.js';
import Game from './components/Game';
import ChickenDroppings from './games/ChickenDroppings/ChickenDroppings';
import TermsAndConditions from './pages/TermsAndConditions';
import '@solana/wallet-adapter-react-ui/styles.css';

export default function App() {
  const network = WalletAdapterNetwork.Devnet;
  const endpoint = useMemo(() => clusterApiUrl(network), [network]);
  const wallets = useMemo(() => [
    new PhantomWalletAdapter(),
    new SolflareWalletAdapter(),
  ], []);

  return (
    <BrowserRouter>
      <ConnectionProvider endpoint={endpoint}>
        <WalletProvider wallets={wallets} autoConnect>
          <WalletModalProvider>
            <Routes>
              <Route path="/" element={<ChickenDroppings />} />
              <Route path="/drop/mini" element={<Game gameType="mini" />} />
              <Route path="/drop/standard" element={<Game gameType="standard" />} />
              <Route path="/drop/mega" element={<Game gameType="mega" />} />
              <Route path="/drop/bonanza" element={<Game gameType="bonanza" />} />
              <Route path="/drop" element={<Navigate to="/drop/mega" replace />} />
              <Route path="/terms" element={<TermsAndConditions />} />
            </Routes>
          </WalletModalProvider>
        </WalletProvider>
      </ConnectionProvider>
    </BrowserRouter>
  );
}
